/* Dealer Direct landing page — page-scoped behaviour.
   Loaded only by sections/dealer-landing-prices and dealer-landing-nav.

   Three small modules, all idempotent and re-runnable so the Customizer's
   shopify:section:load re-render rebinds cleanly:
     DDLPrices  — product tabs + gallery thumbnails
     DDLNav     — scrollspy for the sticky section nav
   Exposed on window.TL.DDL when theme.js has already defined the namespace. */
(function () {
  'use strict';

  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Product tabs + gallery ---------- */
  var DDLPrices = {
    init: function (root) {
      $$('[data-ddl-prices]', root || document).forEach(function (section) {
        DDLPrices.bindTabs(section);
        $$('[data-ddl-gallery]', section).forEach(DDLPrices.bindGallery);
      });
    },

    bindTabs: function (section) {
      var tabs   = $$('[role="tab"]', section);
      var panels = $$('[role="tabpanel"]', section);
      if (!tabs.length || tabs.length !== panels.length) return;

      var select = function (idx, focus) {
        tabs.forEach(function (tab, i) {
          var on = i === idx;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
          panels[i].hidden = !on;
        });
        if (focus) tabs[idx].focus();
      };

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          var last = tabs.length - 1;
          if (e.key === 'ArrowRight') { e.preventDefault(); select(i === last ? 0 : i + 1, true); }
          if (e.key === 'ArrowLeft')  { e.preventDefault(); select(i === 0 ? last : i - 1, true); }
          if (e.key === 'Home')       { e.preventDefault(); select(0, true); }
          if (e.key === 'End')        { e.preventDefault(); select(last, true); }
        });
      });
    },

    /* Every shot is rendered up front and stacked; switching toggles the
       [hidden] attribute instead of swapping src, so the <picture> sources
       (and therefore the WebP candidates) always match what's on screen. */
    bindGallery: function (gallery) {
      var thumbs = $$('[data-ddl-thumb]', gallery);
      var slides = $$('[data-ddl-slide]', gallery);
      if (thumbs.length < 2 || !slides.length) return;

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
          slides.forEach(function (s, si) { s.hidden = si !== i; });
        });
      });
    }
  };

  /* ---------- Sticky nav scrollspy ---------- */
  var DDLNav = {
    observer: null,

    init: function (root) {
      var nav = (root || document).querySelector('[data-ddl-nav]');
      if (!nav) return;

      var links = $$('a[href^="#"]', nav);
      var map = {};
      var targets = [];

      links.forEach(function (link) {
        var id = link.getAttribute('href').slice(1);
        var el = id && document.getElementById(id);
        if (!el) return;
        map[id] = link;
        targets.push(el);
      });
      if (!targets.length) return;

      if (DDLNav.observer) DDLNav.observer.disconnect();
      if (!('IntersectionObserver' in window)) return;

      /* Fires when a band crosses the upper third of the viewport — the band
         under the sticky bar wins, not whatever is merely visible. */
      DDLNav.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (l) { l.classList.remove('is-current'); });
          var current = map[entry.target.id];
          if (current) current.classList.add('is-current');
        });
      }, { rootMargin: '-25% 0px -70% 0px', threshold: 0 });

      targets.forEach(function (t) { DDLNav.observer.observe(t); });
    }
  };

  var init = function (root) {
    DDLPrices.init(root);
    DDLNav.init(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.TL = window.TL || {};
  window.TL.DDL = { Prices: DDLPrices, Nav: DDLNav, init: init };
})();
